import { lazy } from 'react';

export const IncidentMapPage = lazy(() => import('./controller.js'));
